<template lang="pug">
    section#bannerTemplates
        .wrapper
            h2 {{nomePagina}}
</template>

<script>
export default {
    name: "component-banner-templates",
    props:{
        nomePagina: String
    }
}
</script>

<style lang="stylus" scoped src="./BannerTemplates.styl"></style>